<ng-container *ngIf="form">
  <div class="row">
    <div class="title-container">
      <span class="title">Incident ID: {{ form.get('incidentId').value !== 0 ? form.get('incidentId').value : 0 }}</span>
      <div class="status-chip" [ngClass]="form.get('status').value === 1 ? 'finalized' : 'draft'">
        <mat-icon>{{ form.get('status').value === 1 ? 'check_circle' : 'schedule' }}</mat-icon>
        <span class="chip" >{{ form.get('status').value === 1 ? 'Finalized' : 'Draft' }}</span>
      </div>
    </div>
  </div>
  <h2>Text Narratives</h2>
  <div class="row">
    <mat-form-field class="autocomplete">
      <mat-label>Witness</mat-label>
      <input
        type="text"
        aria-label="Witness"
        matInput
        [formControl]="form.get('witness')"
      />
    </mat-form-field>
    <mat-form-field class="autocomplete">
      <mat-label>Foreman</mat-label>
      <input
        type="text"
        aria-label="Foreman"
        matInput
        [formControl]="form.get('foreman')"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Department</mat-label>
      <mat-select [formControl]="form.get('responsibleDept')">
        <mat-option *ngFor="let department of departments" [value]="department">
          {{ department }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Second Department</mat-label>
      <mat-select [formControl]="form.get('responsibleDept2')">
        <mat-option *ngFor="let department of departments" [value]="department">
          {{ department }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="textarea-width">
      <mat-label>Witness Statement</mat-label>
      <textarea
        matInput
        name="Witness Statement"
        rows="5"
        [formControl]="form.get('witnessNarrative')"
      ></textarea>
    </mat-form-field>
    <mat-form-field class="textarea-width">
      <mat-label>Jumper Statement</mat-label>
      <textarea
        matInput
        name="Jumper Statement"
        rows="5"
        [formControl]="form.get('jumperNarrative')"
      ></textarea>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="textarea-width">
      <mat-label>Conclusion and Corrective Action</mat-label>
      <textarea
        matInput
        name="Witness Statement"
        rows="5"
        [formControl]="form.get('conclusion')"
      ></textarea>
    </mat-form-field>
  </div>
  <!-- Photos/Videos Section -->
  <h2>Photos and Videos Info</h2>
  <h4>Files must be smaller than 100mb.</h4>
  <div class="media-list">
    <div class="media-container">
      <div class="row">
        <app-card
          *ngIf="selectedFileOneImgSrc || !form.get('picId1')?.value"
          class="media-card"
          [cardType]="'image-display'"
          [imgSrc]="selectedFileOneImgSrc"
        ></app-card>
        <app-card
          *ngIf="form.get('picId1')?.value && !this.form.get('pic1toUpload').value"
          class="media-card"
          [cardType]="'image-display'"
          imgSrc="{{relativePathToUploadedFiles}}/{{form.get('picId1')?.value}}"
        ></app-card>
        <mat-form-field color="primary" style="width: 300px">
          <mat-label>Photo #1 Description</mat-label>
          <textarea type="text" matInput [formControl]="form.get('picDesc1')" rows="5"></textarea>
        </mat-form-field>
      </div>
      <div class="row">
        <button
          *ngIf="form.get('picId1')?.value || this.form.get('pic1toUpload').value"
          mat-raised-button
          color="warn"
          [disabled]="form.get('status').value=== 1"
          (click)="deletePhoto(1)"
        >Delete Photo</button>
        <input
          accept="image/*"
          #photoInputOne
          style="display: none"
          type="file"
          [formControl]="form.get('photoInputOne')"
          (change)="onPhotoSelectedOne($event)"
        />
        <button type="button" mat-raised-button (click)="photoInputOne.click()">Choose Photo</button>
        <span class="photo-selected-text"
          >Photo Selected: <strong>{{ selectedFileOneName || form.get('picId1')?.value}}</strong>
        </span>
      </div>
    </div>
    <div class="media-container">
      <div class="row">
        <app-card
          *ngIf="selectedFileTwoImgSrc || !form.get('picId2')?.value"
          class="media-card"
          [cardType]="'image-display'"
          [imgSrc]="selectedFileTwoImgSrc"
        ></app-card>
        <app-card
          *ngIf="form.get('picId2')?.value && !this.form.get('pic2toUpload').value"
          class="media-card"
          [cardType]="'image-display'"
          imgSrc="{{relativePathToUploadedFiles}}/{{form.get('picId2')?.value}}"
        ></app-card>
        <mat-form-field color="primary" style="width: 300px">
          <mat-label>Photo #2 Description</mat-label>
          <textarea type="text" matInput [formControl]="form.get('picDesc2')" rows="5"></textarea>
        </mat-form-field>
      </div>
      <div class="row">
        <button
          *ngIf="form.get('picId2')?.value || this.form.get('pic2toUpload').value"
          mat-raised-button
          color="warn"
          [disabled]="form.get('status').value=== 1"
          (click)="deletePhoto(2)"
        >Delete Photo</button>
        <input
          accept="image/*"
          #photoInputTwo
          [formControl]="form.get('photoInputTwo')"
          style="display: none"
          type="file"
          (change)="onPhotoSelectedTwo($event)"
        />
        <button type="button" mat-raised-button (click)="photoInputTwo.click()">Choose Photo</button>
        <span class="photo-selected-text"
          >Photo Selected: <strong>{{ selectedFileTwoName || form.get('picId2')?.value }}</strong>
        </span>
      </div>
    </div>
    <div class="media-container">
      <div class="row">
        <app-card
          *ngIf="selectedFileThreeImgSrc || !form.get('picId3')?.value"
          class="media-card"
          [cardType]="'image-display'"
          [imgSrc]="selectedFileThreeImgSrc"
        ></app-card>
        <app-card
          *ngIf="form.get('picId3')?.value && !this.form.get('pic3toUpload').value"
          class="media-card"
          [cardType]="'image-display'"
          imgSrc="{{relativePathToUploadedFiles}}/{{form.get('picId3')?.value}}"
        ></app-card>
        <mat-form-field color="primary" style="width: 300px">
          <mat-label>Photo #3 Description</mat-label>
          <textarea type="text" matInput [formControl]="form.get('picDesc3')" rows="5"></textarea>
        </mat-form-field>
      </div>
      <div class="row">
        <button
          *ngIf="form.get('picId3')?.value || this.form.get('pic3toUpload').value"
          mat-raised-button
          color="warn"
          [disabled]="form.get('status').value=== 1"
          (click)="deletePhoto(3)"
        >Delete Photo</button>
        <input
          accept="image/*"
          #photoInputThree
          [formControl]="form.get('photoInputThree')"
          style="display: none"
          type="file"
          (change)="onPhotoSelectedThree($event)"
        />
        <button type="button" mat-raised-button (click)="photoInputThree.click()">Choose Photo</button>
        <span class="photo-selected-text"
          >Photo Selected: <strong>{{ selectedFileThreeName || form.get('picId3')?.value }}</strong>
        </span>
      </div>
    </div>
    <div class="media-container">
      <div class="row">
        <app-card
          *ngIf="!form.get('videoId1')?.value || form.get('videoToUpload')?.value"
          class="media-card"
          [cardType]="'video-display'"
          [videoSrc]="selectedVideoSrc"
          [videoType]="selectedVideoType"
        ></app-card>
        <app-card
          *ngIf="form.get('videoId1')?.value && !form.get('videoToUpload')?.value"
          class="media-card"
          [cardType]="'video-display'"
          videoSrc="{{relativePathToUploadedFiles}}/{{form.get('videoId1')?.value}}"
        ></app-card>
        <mat-form-field color="primary" style="width: 300px">
          <mat-label>Video Description</mat-label>
          <textarea type="text" matInput [formControl]="form.get('videoDesc1')" rows="5"> </textarea>
        </mat-form-field>
      </div>
      <div class="row">
        <button
          *ngIf="form.get('videoId1')?.value || form.get('videoToUpload')?.value"
          mat-raised-button
          color="warn"
          [disabled]="form.get('status').value=== 1"
          (click)="deleteVideo()"
        >Delete Video</button>
        <input
          #videoInput
          [formControl]="form.get('videoInput')"
          style="display: none"
          type="file"
          accept="video/*"
          (change)="onVideoSelected($event)"
        />
        <button type="button" mat-raised-button (click)="videoInput.click()">Choose Video</button>
        <span class="photo-selected-text"
          >Video Selected: <strong>{{ selectedVideoName || form.get('videoId1')?.value }}</strong>
        </span>
      </div>
    </div>
  </div>
</ng-container>
